// extracted by mini-css-extract-plugin
export default {"root":"ButtonOption_root__Ogajc"};